
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.117 13.426a.4.4 0 00.566 0l6.246-6.247a.1.1 0 01.142 0l6.246 6.247a.4.4 0 10.566-.566l-6.247-6.246a.9.9 0 00-1.272 0L3.117 12.86a.4.4 0 000 .566z","fill":"#282830"}})])
      }
    
      }
    